/**
 * partial list of FinancialAccountType from Core
 * some of the names here map differently to the names in Core
 * see `FinancialAccountActivityService.ReportTitleForAccountTypeId` in the C# codebase
 */
export enum FinancialAccountType {
  /**
   * Credit Limit
   */
  PurchasedInvoices = 11,
  /**
   * Revenue Share
   */
  PayorRebate = 20,
  PayorRefunds = 22,
}

export enum SettlementStatementType {
  Legacy = 1,
  MonthlyStatement = 2,
  RefundStatement = 3,
  WeeklyStatement = 4,
  MonthlyStatementV2 = 5,
}

export const monthlySettlementStatementTypes: SettlementStatementType[] = [
  SettlementStatementType.Legacy,
  SettlementStatementType.MonthlyStatement,
  SettlementStatementType.RefundStatement,
  SettlementStatementType.MonthlyStatementV2,
];

export const weeklySettlementStatementTypes: SettlementStatementType[] = [
  SettlementStatementType.WeeklyStatement,
];

// see TBC.TriumphPay.Model.SettlementStatements.SettlementStatementService.SettlementInfo.IsMonthlySettlement
export const settlementStatementLineItemTypes: Record<SettlementStatementType, boolean> = {
  [SettlementStatementType.Legacy]: false,
  [SettlementStatementType.MonthlyStatement]: true,
  [SettlementStatementType.RefundStatement]: false,
  [SettlementStatementType.WeeklyStatement]: true,
  [SettlementStatementType.MonthlyStatementV2]: true,
};
